<template>
  <div>
    <h3 v-if="!insideLabel && hasLabel" class="mb-3">{{ label }}</h3>
    <v-text-field
      v-if="!textarea"
      @input="handleInput"
      :autocomplete="autocomplete"
      :placeholder="placeholder"
      :readonly="readOnly"
      :disabled="disabled"
      :dense="dense"
      :value="value"
      :rules="rules"
      :error="error"
      :type="type"
      :label="insideLabel ? label : ''"
      outlined
    />
    <v-textarea
      v-else
      @input="handleInput"
      :placeholder="placeholder"
      :readonly="readOnly"
      :disabled="disabled"
      :rules="rules"
      :value="value"
      :counter="counter"
      outlined
      dense
    />
  </div>
</template>

<script>
export default {
  name: 'HTextInput',
  props: {
    value: {
      required: true,
    },
    placeholder: {
      type: String,
      required: false,
      default: '',
    },
    label: {
      type: String,
      required: false,
    },
    textarea: {
      type: Boolean,
      required: false,
      default: false,
    },
    type: {
      type: String,
      default: 'text',
    },
    readOnly: Boolean,
    disabled: Boolean,
    rules: {
      required: false,
    },
    dense: {
      default: false,
    },

    error: {
      type: Boolean,
      default: false,
    },

    autocomplete: {
      type: String,
      default: ''
    },

    counter: {
      type: Boolean,
      default: false
    },

    insideLabel: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    hasLabel() {
      return this.label?.trim().length > 0
    },
  },
  methods: {
    handleInput(value) {
      this.$emit('input', value)
    },
  },
}
</script>
